import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { IEmailMessage, IEmailMessageContent } from 'src/app/shared/models/emailMessage';
import { IPagedResult } from 'src/app/shared/models/pagedResult';
import { BaseService } from './base.service';
import { ApiVersions } from './api-version';

@Injectable()
export class EmailMessageService extends BaseService {
  private basePath = 'emailMessages';

  private invitationEmailSent = new BehaviorSubject(false);
  currentInvitationEmailSent = this.invitationEmailSent.asObservable();

  constructor() {
    super();
  }

  updateInvitationEmail(message: boolean) {
    this.invitationEmailSent.next(message);
  }

  findMessages(
    pageIndex: number,
    pageSize: number,
    searchInput?: string,
    personId?: string,
    deliveryStatus?: string,
    messageType?: string
  ): Observable<IPagedResult<IEmailMessage>> {
    return this.get<IPagedResult<IEmailMessage>>(
      this.basePath,
      {
        params: {
          pageIndex: String(pageIndex),
          pageSize: String(pageSize),
          ...(searchInput ? { searchInput: searchInput.trim() } : undefined),
          ...(personId ? { personId: personId.trim() } : undefined),
          ...(deliveryStatus ? { deliveryStatus } : undefined),
          ...(messageType ? { messageType } : undefined)
        }
      },
      ApiVersions.v1_0
    );
  }

  getMessage(email: string, teamId: string): Observable<IEmailMessage> {
    return this.get<IEmailMessage>(`${this.basePath}/${email}/team/${teamId}`);
  }

  fetchContent(id: string): Observable<IEmailMessageContent> {
    return this.get<IEmailMessageContent>(`${this.basePath}/${id}/content`, true);
  }

  resend(id: string): Observable<unknown> {
    // rethrowError: without it the shared handler turns a failure into a null emission on the
    // success path, and the caller reports a resend that never happened
    return this.post(`${this.basePath}/${id}/resend`, null, undefined, undefined, true);
  }
}
